var _rect, _rect2, _rect3, _rect4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconOpacity = function SvgIconOpacity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#fff",
    rx: 6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    x: 0.5,
    y: 0.5,
    fill: "url(#icon_opacity_svg__a)",
    fillOpacity: 0.1,
    rx: 5.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    x: 0.5,
    y: 0.5,
    fill: "#000",
    fillOpacity: 0.3,
    rx: 5.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    x: 0.5,
    y: 0.5,
    stroke: "#CCC",
    rx: 5.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "icon_opacity_svg__a",
    width: 0.533,
    height: 0.533,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon_opacity_svg__b",
    transform: "scale(.00833)"
  })), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAA40lEQVR4Xu3bQQ6EQAhEUbj/oXsO8Sdh4XOvJAi/qkF3Zt6E6710++xuiD6T40uACtACqYlzD2IACFKBkoHcgmSQDJJBMngKIT6ADygF6DSYfcCLTzg/z0eGrASogDbT0gKxB2MB5pkiBoBgrEEMwIBjLx9fAAiCIAhygmkkRgYjhWMHditsL2AvYC+QIHjdwzk+BmAABmBAWc1kCF0bKRAEQRAEQRAMGaACbaCUz/P5BRiKxhQaiV07uRjfYgQDMKDpGAhGCMUCzD4CBEEw1iAGYIBPZMJh+g8/P8cKpAJfV4EfMee/sLtaEFIAAAAASUVORK5CYII=",
    id: "icon_opacity_svg__b",
    width: 64,
    height: 64
  }))));
};
export default SvgIconOpacity;